import React from 'react';
import {
    MenuItem,
    Menu,
    ClickAwayListener,
} from "@material-ui/core";
import clsx from 'clsx';


//  This component renders a dropdown mechanism that has a fix text-label and we select from predefined options.
const DropdownMechanismFixLabel = (props) => {

    const {
        ElementTypes,
        addElement,
        label
    } = props

    const [clickedAddElement, setClickedAddElement] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);

    //  This function closes the  menu with the options to add
    const closeMenu = () => {
        setClickedAddElement(false);
        setAnchorEl(null)
    }

    //  This function opens the menu with the new options to add
    const buttonfunction = (event) => {
        setClickedAddElement(true);
        setAnchorEl(event.currentTarget);
    }

    return(
        <>
            <span 
                className={clsx('teamSelector', 'spacingDownDiv')} 
                onClick={(event) => buttonfunction(event)}
                style={{ display: 'inline-block'}}
                aria-hidden="true"
            >
                <span 
                    style={{fontSize: '0.7vw'}}
                    className={clsx('lightBlue')}>
                        {label} &nbsp;
                    </span>
            
                {clickedAddElement === false  ? 
                    <i className={clsx('fa', 'fa-caret-down', 'fa-caret-down3')}> </i>
                    : 
                    <ClickAwayListener 
                        onClickAway ={closeMenu}
                    >
                        <i className={clsx('fa', 'fa-caret-up', 'fa-caret-up3', 'teamSelector')} />
                    </ClickAwayListener>
                }    
            </span>
            <Menu   
                elevation={0}
                getContentAnchorEl={null}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                anchorEl={anchorEl}
                keepMounted
                open={clickedAddElement}
                >   
                    {
                        ElementTypes.map((option) => (
                            <MenuItem 
                                key={option}
                                onClick ={() => addElement(option)}
                            > 
                                {option}
                            </MenuItem>
                        ))
                    }
            </Menu>
        </>
    )

}

export default DropdownMechanismFixLabel;